import { Helmet } from 'react-helmet'
import * as React from 'react'

type Props = {
  title: string
  description: string
  path: string
  meta?: Helmet['meta']
}

const SEO: React.FC<Props> = ({ title, description, path, meta }) => {
  const baseTitle = 'Sense Island -感覚の島- 暗闇の美術島 2021'
  const baseUrl = 'https://senseisland.com'
  const url = `${baseUrl}${path}`
  const shareImage = `${baseUrl}/images/share.png`
  const keyword = ''
  const ogType = path === '/' ? 'website' : 'article'

  return (
    <Helmet
      title={title}
      meta={[
        {
          name: 'description',
          content: description,
        },

        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: description,
        },
        {
          property: 'og:url',
          content: url,
        },
        {
          property: 'og:image',
          content: shareImage,
        },
        {
          property: 'og:type',
          content: ogType,
        },
        {
          property: 'og:site_name',
          content: baseTitle,
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: description,
        },
        {
          name: 'twitter:url',
          content: url,
        },
        {
          name: 'twitter:image',
          content: shareImage,
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'keyword',
          content: keyword,
        },
      ].concat(meta || [])}
    >
      <script
        type="text/javascript"
        src="//typesquare.com/3/tsst/script/ja/typesquare.js?5YYAC0xT8Kg%3D&auto_load_font=true"
        charset="utf-8"
      ></script>
    </Helmet>
  )
}

export default SEO
